
import LoadingActionContext from '@/contexts/data/LoadingActionContext';
import LoadingContext from '@/contexts/data/LoadingContext';
import IHasChildren from '@/types/components/IHasChildren';
import { FC, PropsWithChildren, useMemo, useState } from 'react';


export interface ILoadingContextProps {

}


export const LoadingProvider: FC<PropsWithChildren<ILoadingContextProps>> = ({ children }) => {
    const [loading, setLoading] = useState<{ loading: boolean; validating: boolean; state: Record<string, { loading: boolean; validating: boolean; }> }>({ loading: false, validating: false, state: {}});

    const actions = useMemo(() => {
        return {
            setComplete: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                loading: false
                            }
                        } 
                    };

                    update.loading = Object.keys(update.state).some(x => update.state[x]?.loading === true);

                    return update;
                });
            },
            setLoading: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                loading: true
                            }
                        } 
                    };

                    update.loading = Object.keys(update.state).some(x => update.state[x]?.loading === true);

                    return update;
                });
            },
            setValid: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                validating: false
                            }
                        } 
                    };

                    update.validating = Object.keys(update.state).some(x => update.state[x]?.loading !== true && update.state[x]?.validating === true);

                    return update;
                });
            },
            setValidating: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                validating: true
                            }
                        } 
                    };

                    update.validating = Object.keys(update.state).some(x => update.state[x]?.loading !== true && update.state[x]?.validating === true);

                    return update;
                });
            }
        }
    }, [setLoading])

    const context = useMemo(() => {
        return {
            loading: loading.loading,
            validating: loading.validating
        }
    }, [loading.loading, loading.validating])

    return (

        <LoadingActionContext.Provider value={actions}>
            <LoadingContext.Provider value={context}>
                {children}
            </LoadingContext.Provider>
        </LoadingActionContext.Provider>
    );
}

export default LoadingProvider;